module.exports = __webpack_public_path__ + "img/c03_unitcarpentom_Normal_ua.e26142c3.webp";